module.exports = __webpack_public_path__ + "img/pic3.e7160e7c.png";